import { render, staticRenderFns } from "./clockDialog.vue?vue&type=template&id=7ca3190f&"
import script from "./clockDialog.vue?vue&type=script&lang=js&"
export * from "./clockDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports